const btnViewMore = document.querySelector('.collection__view-more button')
!!btnViewMore && btnViewMore.addEventListener('click', () => {
  const description = document.querySelector('.collection_description.rte')
  const textMore = document.querySelector('.moreText')
  description.classList.toggle('expand')
  btnViewMore.classList.toggle('expand')
  btnViewMore.classList.contains('expand') ? (textMore.innerHTML = 'see less') : (textMore.innerHTML = 'view more')
})


const container = document.querySelector('.content-slide-icons')
const toggleModalProduct = [... document.querySelectorAll('.icon-suite a')]
!!toggleModalProduct && toggleModalProduct.map(button => {
  button.addEventListener('click', () => {
    container.classList.add('active')
    const contianerVisually = button.parentElement.querySelector('.visually-hidden')
    const wrapper = container.querySelector('.wrapper-content')
    wrapper.innerHTML = contianerVisually.innerHTML
  })
})

const buttonModalClose = document.querySelector('.icon-close')
!!buttonModalClose && buttonModalClose.addEventListener('click', () => container.classList.remove('active'))

// FIX (2026-09-27): the code below used to run unconditionally, throwing
// "Cannot read properties of null (reading 'getAttribute')" on every page
// that has no `.variants-json` element (home, collection, cart, blog, etc.),
// which stopped the rest of this file (the sold-out size-graying logic)
// from ever registering on those pages. Guarded with null checks instead.
const variantsJsonEl = document.querySelector('.variants-json')
const variants = variantsJsonEl ? JSON.parse(variantsJsonEl.getAttribute('data-variants')) : null

const availabilityVariants = (select) => {
  clearInterval(searchSelect)
  if (!variants) return

  const options = [... select.options]
  options.map(option => {
    const variant = variants.find(variant => variant.title == option.value || variant.option1 == option.value )
    if(!variant || !!variant.available) return

     option.innerHTML = `${variant.title} - Sold Out`
     option.disabled = true
  })
}

const searchSelect = setInterval(() => {
  const findSelect = document.querySelector('select.single-option-selector')
  !!findSelect && variants && availabilityVariants(findSelect)
}, 1000);
